import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ProgressBarPointer = styled.div<React.CSSProperties>`
  background: ${Colors['progress']['fill']};
  border-radius: ${5 * Screen.widthRatio}px;
  bottom: ${-7 * Screen.widthRatio}px;
  right: ${-7 * Screen.widthRatio}px;
  position: inherit;
  height: ${26 * Screen.widthRatio}px;
  width: ${10 * Screen.widthRatio}px;
`;

export default ProgressBarPointer;
